<aside class="sidebar-shell">

    <div class="logo-wrapper">
        @if (PRODUCTION === false) {
            <div class="line">STAGING</div>
        }
        <a routerLink="/app" class="logo">
            <img src="assets/logo-white.png" alt="dyno-chiptuning files.com"/>
        </a>
    </div>

    <app-select-partner></app-select-partner>

    <div class="fixed-home">
        <ul>
            <li routerLink="/app" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                (click)="closeMobileNav()">
                <a>
                    <i class="bi bi-house"></i>
                    <span>Home</span>
                </a>
            </li>
        </ul>
    </div>

    <nav class="sidebar-nav">
        @if (isSmallScreen() && isAdmin()) {
            <div class="mobile-widgets">
                @if (statisticService.isOpened()) {
                    <app-sidebar-server-stats
                            [isSideBarOpened]="statisticService.isOpened()"></app-sidebar-server-stats>
                }
                <div class="files-in-queue-card">
                    <app-number-of-files-in-queue></app-number-of-files-in-queue>
                </div>
            </div>
        }
        <app-sidebar-list></app-sidebar-list>
    </nav>

</aside>
